<nb-card>
    <nb-card-header>{{ 'Scenarii management' | translate }}</nb-card-header>
    <nb-card-body>
        <app-ag-grid-scenarii></app-ag-grid-scenarii>
    </nb-card-body>
    <nb-card-footer>
        <button nbButton (click)="close()" class="cancel">{{ "Cancel" | translate }}</button>
        <button nbButton (click)="close()">{{ "ok" | translate }}</button>
    </nb-card-footer>
</nb-card>